import { call, put, takeLatest } from 'redux-saga/effects';
import { emitStartupEvent } from '../utils/ct-events';
import { getUserDetails } from './user';
import { fetchMarketingBanner } from './marketingBanner';

const INIT = 'init';

export function init() {
  return { type: INIT };
}

function* initSaga() {
  yield put(getUserDetails());
  yield put(fetchMarketingBanner());
  yield call(emitStartupEvent);
}

function* setupSagas() {
  yield takeLatest(INIT, initSaga);
}

export default { saga: setupSagas };
